import MenuIcon from '@mui/icons-material/Menu';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import './main-layout.styles.scss';
import MainRouter from './main-route.component';
import { isNotNull } from './util.services';
import IButton from '../../components/button/i-button.component';
import { AppContext } from '../../app-context';
import { ACCESS_TOKEN, EMPTY_STRING } from './constants';
import { Collapse} from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';

const drawerWidth = "10%";

interface Props {
  /**
   * Injected by the documentation to work in an iframe.
   * Remove this when copying and pasting into your project.
   */
  window1?: () => Window;
}

function ResponsiveDrawer(props: Props) {
  const appContext = React.useContext(AppContext);
  const { window1 } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [isClosing, setIsClosing] = React.useState(false);
  const navigate = useNavigate();
  //const [userData, setUserData] = React.useState(null);
  /*React.useEffect(() => {
    if (appContext.userData) {
      setUserData(appContext.userData);
    }
  }, [appContext.userData]);*/

  const logout = () => {
    appContext.setUserData(EMPTY_STRING);
    localStorage.setItem(ACCESS_TOKEN, EMPTY_STRING);
    navigate(`/signin`)
  }
  
  const goToUrl = (name: string, url: string) => {
    if('Logout' === name) {
      appContext.setUserData(EMPTY_STRING);
      localStorage.setItem(ACCESS_TOKEN, EMPTY_STRING);
      navigate(`/signin`)
    } else if(!url.includes('nourl')) {
      navigate(`/${url}`);
    }
  }

  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };

  const isSelected = (url: any) => {
    return window.location.href.includes(url);
  };

  function createMenuList() {
    let menuList = [{ name: 'Enquiry', url: 'enquiry/list' },
                    { name: 'Costing', url: 'costing/list' },
                    { name: 'Order', url: 'order/list' },
                    { name: 'PO/JS/Challan', url: 'pojo/list' },
                    { name: 'Stock', 
                      subMenu: [
                        { name: 'List', url: 'stock/list' },
                        { name: 'Ledger', url: 'stock/ledger' }]},
                    { name: 'Schedule', url: 'production/schedule/list' },
                    { name: 'Order Task', url: 'task/order/list' },
                    { name: 'General Task', 
                      subMenu: [
                        { name: 'Manage Task', url: 'task/general/list' },
                        { name: 'My Task', url: 'task/general/mytask' }]},
                    { name: 'Master Data', url: 'master-data/list'}];
    
    let amazon = { name: 'Amazon',
                   subMenu: [
                    { name: 'Order Perf', url: 'amazon/perf/order' },
                    { name: 'Sale Perf', url: 'amazon/perf/sale' },
                    { name: 'Transaction', url: 'amazon/transaction' },
                    { name: 'Sync Status', url: 'amazon/syncstatus' },
                    { name: 'Ad Cost', url: 'amazon/tacos' },
                    { name: 'Ad Spend', url: 'amazon/adspendsku' },
                    { name: 'Inventory', url: 'amazon/inventory' },
                    { name: 'Costing', url: 'amazon/prdcosting' },
                    { name: 'Fee', url: 'amazon/fee' },
                    { name: 'All Order', url: 'amazon/allorder' },
                    { name: 'Product Order', url: 'amazon/productsale' },
                    { name: 'Product Margin', url: 'amazon/productmargin' },
                    { name: 'Return', url: 'amazon/return' },
                    { name: 'Daily Order', url: 'amazon/dailyorder' },
                    { name: 'Virtual Product', url: 'amazon/virtualproduct' },
                    { name: 'Sync Report', url: 'amazon/syncreport' },
                    { name: 'Parameter', url: 'amazon/parameter' },
                    { name: 'Log', url: 'amazon/log' }]};
    let customer = { name: 'Customer', url: 'customer/list' };
    let supplier = { name: 'Supplier', url: 'supplier/list' };
    let products = { name: 'Product', url: 'products/list' };
    let process = { name: 'Process', url: 'production/process/list' };
    let currency = { name: 'Currency', url: 'currency/list' };
    let logging = { name: 'Logging', url: 'logging/list' };
    let user = { name: 'Employee', url: 'user/list' };
    let logout = { name: 'Logout', url: 'logout' };
    let close = { name: 'Close', url: 'nourl' };

    if('LFHADMIN' === appContext.userData.role || 
       'AMZUSER' === appContext.userData.role ||
       'AMZUSEREDIT' === appContext.userData.role) {
      menuList.push(amazon);
    }

    menuList.push(customer);
    menuList.push(supplier);
    menuList.push(products);
    menuList.push(process);
    menuList.push(currency);
    menuList.push(logging);
    menuList.push(user);
    menuList.push(logout);
    menuList.push(close);

    return menuList;
  }
  
  const menuList = createMenuList();

  const initialState = Object.fromEntries(menuList.map((i) => [i.name, false]));
  const [open, setOpen] = React.useState(initialState);

  const handleClick = (menu: string) => {
    setOpen((o) => ({ ...initialState, [menu]: !o[menu] }));
  };

  function getMenu() {
    return (
        <List>
          {menuList.map((menu, index) => {
            if (menu.subMenu) {
              return (
                <div key={menu.name}>
                  <ListItemButton onClick={() => handleClick(menu.name)}>
                    <ListItemText primary={menu.name} />
                    {open[menu.name] ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>
                  <Collapse in={open[menu.name]} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      {menu.subMenu.map((subMenu: any, index: number) => (
                        <span key={subMenu.name}>
                          <ListItemButton sx={{ pl: 4 }} onClick={() => { goToUrl(subMenu.name, subMenu.url) }}
                            selected={isSelected(subMenu.url)} className='nav-item' >
                            <ListItemText primary={subMenu.name} />
                          </ListItemButton>
                        </span>
                      ))}
                    </List>
                  </Collapse>
                </div>
              );
            } else {
              return (
                <div key={menu.name}>
                  <span>
                    <ListItem disablePadding>
                      <ListItemButton onClick={() => { goToUrl(menu.name, menu.url) }}
                        selected={isSelected(menu.url)} className='nav-item' >
                        <ListItemText primary={menu.name} />
                      </ListItemButton>
                    </ListItem>
                  </span>
                </div>
              );
            }
          })}
        </List>
    );
  }

  const drawer = ( getMenu() );

  const container = window1 !== undefined ? () => window1().document.body : undefined;

  return (
    <>
      <AppBar position="fixed"
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div" className="app-title">
            LFH Home ERP System
          </Typography>
        </Toolbar>
      </AppBar>
      <Box sx={{ display: 'flex' }}>
        {/* <CssBaseline /> */}
        <Box
          component="nav"
          sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
          aria-label="mailbox folders"
        >
          {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onTransitionEnd={handleDrawerTransitionEnd}
            onClose={handleDrawerClose}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              display: { xs: 'block', sm: 'none' },
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            }}
          >
            {drawer}
          </Drawer>
          <Drawer
            variant="persistent"
            sx={{
              display: { xs: 'none', sm: 'block' },
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, marginTop: '65px' },
            }}
            open
          >
            {drawer}
            {isNotNull(null/*userData*/) && <div className="logout-btn">
              <IButton onActionEvent={() => { logout() }} label='logout' variant="text" />
            </div>}
          </Drawer>
        </Box>
        <Box
          component="main"
          sx={{ flexGrow: 1, p: 3, width: { sm: `calc(95% - ${drawerWidth})` } }}
        >
          <MainRouter />
        </Box>
      </Box>
    </>
  );
}

export default ResponsiveDrawer
